{
  "ar-AR": {
    "ruminants": "المجترات",
    "areRuminats": "هذه مجترات.",
    "whatIsARuminat": "ما هو المجتر؟",
    "ruminatDefinition": "المجترات هي حيوانات رعي حوافر أو ثدييات قادرة على الحصول على المغذيات من الأطعمة النباتية عن طريق تخميرها في معدة متخصصة قبل الهضم ، بشكل أساسي من خلال الإجراءات الميكروبية.",
    "cow": "بقرة",
    "goat": "معزة",
    "chicken": "فرخة",
    "sheep": "غنم",
    "color": "Adobe لون",
    "colorError": "ليس لون Adobe صالحًا",
    "farmAnimalCount": "عدد حيوانات المزرعة",
    "farmCountError": "اختر رقمًا صالحًا",
    "notRuminatError": "هذا الحيوان ليس مجترًا.",
    "ageRange": "الفئة العمرية",
    "cheeseSearch": "البحث عن الجبن",
    "findCheese": "أدخل جبنًا صالحًا للعثور على الأصل والتاريخ والوصفة.",
    "farmScore": "نتيجة المزرعة",
    "amHappy": "هل أنت سعيد؟",
    "clients": "قائمة العملاء",
    "clientsError": "أدخل قائمة العملاء.",
    "clientHeading": "قائمة العملاء",
    "clientContent": "قائمة مفصولة بفواصل لجميع العملاء.",
    "farmName": "اسم المزرعة",
    "brownFenceFarm": "مزرعة السور البني",
    "farmDescription": "أدخل اسم مزرعتك.",
    "farmTitle": "الاسم القانوني للمزرعة",
    "farmLegal": "يجب أن يكون هذا الاسم القانوني للمزرعة وليس اسمًا مستعارًا أو اسم تسويق."
  },
  "en-US": {
    "ruminants": "Ruminants",
    "areRuminats": "These are ruminants.",
    "whatIsARuminat": "What is a ruminat?",
    "ruminatDefinition": "Ruminants are hoofed herbivorous grazing or browsing mammals that are able to acquire nutrients from plant-based food by fermenting it in a specialized stomach prior to digestion, principally through microbial actions.",
    "cow": "Cow",
    "goat": "Goat",
    "chicken": "Chicken",
    "sheep": "Sheep",
    "color": "Adobe color",
    "colorError": "Not a valid Adobe color",
    "farmAnimalCount": "Farm animal count",
    "farmCountError": "Choose a valid number",
    "notRuminatError": "This animal is not a ruminant.",
    "ageRange": "Age range",
    "cheeseSearch": "Cheese search",
    "findCheese": "Enter a valid cheese to find origin, history, and recipe.",
    "farmScore": "Farm score",
    "amHappy": "Are you happy?",
    "clients": "List of clients",
    "clientsError": "Enter client list.",
    "clientHeading": "Client list",
    "clientContent": "Comma seperated list of all clients.",
    "farmName": "Farm name",
    "brownFenceFarm": "Brown Fence Farm",
    "farmDescription": "Enter the name of your farm.",
    "farmTitle": "Legal name of farm",
    "farmLegal": "This should be the legal name of the farm and not an alias or marketing name."
  },
  "he-IL": {
    "ruminants": "מעלי גירה",
    "areRuminats": "אלה בעלי גירה.",
    "whatIsARuminat": "מה זה גירה?",
    "ruminatDefinition": "גירה הם יונקים אוכלי עשב פרסות שרועות או גולשים המסוגלים לרכוש חומרים מזינים ממזון צמחי על ידי תסיסתו בקיבה מיוחדת לפני העיכול, בעיקר באמצעות פעולות מיקרוביאליות.",
    "cow": "פָּרָה",
    "goat": "עֵז",
    "chicken": "עוף",
    "sheep": "כבשים",
    "color": "Adobe צֶבַע",
    "colorError": "לא צבע Adobe חוקי",
    "farmAnimalCount": "ספירת חיות משק",
    "farmCountError": "בחר מספר חוקי",
    "notRuminatError": "בעל חיים זה אינו מעלה גירה.",
    "ageRange": "טווח גילאים",
    "cheeseSearch": "חיפוש גבינה",
    "findCheese": "הזן גבינה חוקית כדי למצוא מקור, היסטוריה ומתכון.",
    "farmScore": "ציון החווה",
    "amHappy": "האם אתה שמח?",
    "clients": "רשימת לקוחות",
    "clientsError": "היכנס לרשימת לקוחות.",
    "clientHeading": "רשימת לקוחות",
    "clientContent": "רשימה מופרדת בפסיק של כל הלקוחות.",
    "farmName": "שם החווה",
    "brownFenceFarm": "חוות גדר חומה",
    "farmDescription": "הזן את שם החווה שלך.",
    "farmTitle": "השם החוקי של החווה",
    "farmLegal": "זה צריך להיות השם החוקי של החווה ולא כינוי או שם שיווקי."
  },
  "ja-JP": {
    "ruminants": "反芻動物",
    "areRuminats": "これらは反芻動物です。",
    "whatIsARuminat": "反芻動物とは？",
    "ruminatDefinition": "反芻動物は、主に微生物の作用を通じて、消化前に特殊な胃で発酵させることにより、植物ベースの食物から栄養素を取得できる草食性の草食または閲覧する有蹄動物です。",
    "cow": "牛",
    "goat": "ヤギ",
    "chicken": "鶏",
    "sheep": "羊",
    "color": "Adobe 色",
    "colorError": "有効な Adob​​e カラーではありません",
    "farmAnimalCount": "家畜数",
    "farmCountError": "有効な番号を選択してください",
    "notRuminatError": "この動物は反芻動物ではありません",
    "ageRange": "年齢層",
    "cheeseSearch": "チーズ検索",
    "findCheese": "有効なチーズを入力して、起源、歴史、レシピを検索してください。",
    "farmScore": "農場スコア",
    "amHappy": "幸せですか？",
    "clients": "クライアント一覧",
    "clientsError": "顧客リストを入力します。",
    "clientHeading": "クライアントリスト",
    "clientContent": "すべてのクライアントのカンマ区切りリスト。",
    "farmName": "農場名",
    "brownFenceFarm": "ブラウン フェンス ファーム",
    "farmDescription": "農場の名前を入力します。",
    "farmTitle": "農場の正式名称",
    "farmLegal": "これは農場の正式な名前であり、エイリアスやマーケティング名ではありません。"
  },
  "ko-KR": {
    "ruminants": "반추 동물",
    "areRuminats": "이들은 반추 동물입니다.",
    "whatIsARuminat": "반추동물이란?",
    "ruminatDefinition": "반추동물은 발굽이 있는 초식성 방목 또는 브라우징 포유류로, 주로 미생물 작용을 통해 소화하기 전에 특수 위장에서 식물성 식품을 발효시켜 영양분을 얻을 수 있습니다.",
    "cow": "암소",
    "goat": "염소",
    "chicken": "닭",
    "sheep": "양",
    "color": "Adobe 색상",
    "colorError": "유효한 Adobe 색상이 아닙니다.",
    "farmAnimalCount": "농장 동물 수",
    "farmCountError": "유효한 번호를 선택하세요",
    "notRuminatError": "이 동물은 반추 동물이 아닙니다.",
    "ageRange": "연령대",
    "cheeseSearch": "치즈 검색",
    "findCheese": "원산지, 역사 및 조리법을 찾으려면 유효한 치즈를 입력하십시오.",
    "farmScore": "농장 점수",
    "amHappy": "행복하니?",
    "clients": "클라이언트 목록",
    "clientsError": "클라이언트 목록을 입력하십시오.",
    "clientHeading": "클라이언트 목록",
    "clientContent": "모든 클라이언트의 쉼표로 구분된 목록입니다.",
    "farmName": "농장 이름",
    "brownFenceFarm": "갈색 울타리 농장",
    "farmDescription": "농장 이름을 입력하세요.",
    "farmTitle": "농장의 법적 이름",
    "farmLegal": "별칭이나 마케팅 이름이 아니라 팜의 법적 이름이어야 합니다."
  },
  "zh-CN": {
    "ruminants": "反刍动物",
    "areRuminats": "这些是反刍动物。",
    "whatIsARuminat": "什么是反刍动物？",
    "ruminatDefinition": "反刍动物是有蹄的草食性食草或浏览哺乳动物，它们能够通过在消化前在专门的胃中发酵来从植物性食物中获取营养，主要是通过微生物作用。",
    "cow": "奶牛",
    "goat": "山羊",
    "chicken": "鸡",
    "sheep": "羊",
    "color": "Adobe 颜色",
    "colorError": "不是有效的 Adob​​e 颜色",
    "farmAnimalCount": "农场动物数量",
    "farmCountError": "选择一个有效的号码",
    "notRuminatError": "这种动物不是反刍动物。",
    "ageRange": "年龄范围",
    "cheeseSearch": "奶酪搜索",
    "findCheese": "输入有效的奶酪以查找产地、历史和配方。",
    "farmScore": "农场分数",
    "amHappy": "你快乐吗？",
    "clients": "客户名单",
    "clientsError": "输入客户名单。",
    "clientHeading": "客户名单",
    "clientContent": "所有客户端的逗号分隔列表。",
    "farmName": "农场名称",
    "brownFenceFarm": "布朗栅栏农场",
    "farmDescription": "输入您农场的名称。",
    "farmTitle": "农场的法定名称",
    "farmLegal": "这应该是农场的法定名称，而不是别名或营销名称。"
  },
  "zh-TW": {
    "ruminants": "反芻動物",
    "areRuminats": "這些是反芻動物。",
    "whatIsARuminat": "什麼是反芻動物？",
    "ruminatDefinition": "反芻動物是有蹄的草食性食草或瀏覽哺乳動物，它們能夠通過在消化前在專門的胃中發酵來從植物性食物中獲取營養，主要是通過微生物作用。",
    "cow": "奶牛",
    "goat": "山羊",
    "chicken": "雞",
    "sheep": "羊",
    "color": "Adobe 顏色",
    "colorError": "不是有效的 Adob​​e 顏色",
    "farmAnimalCount": "農場動物數量",
    "farmCountError": "選擇一個有效的號碼",
    "notRuminatError": "這種動物不是反芻動物。",
    "ageRange": "年齡範圍",
    "cheeseSearch": "奶酪搜索",
    "findCheese": "輸入有效的奶酪以查找產地、歷史和配方。",
    "farmScore": "農場分數",
    "amHappy": "你快樂嗎？",
    "clients": "客戶名單",
    "clientsError": "輸入客戶名單。",
    "clientHeading": "客戶名單",
    "clientContent": "所有客戶端的逗號分隔列表。",
    "farmName": "農場名稱",
    "brownFenceFarm": "布朗柵欄農場",
    "farmDescription": "輸入您農場的名稱。",
    "farmTitle": "農場的法定名稱",
    "farmLegal": "這應該是農場的法定名稱，而不是別名或營銷名稱。"
  }
}
